export const state = {
  // product: undefined,
  // products: []
  programme: {},
  programmes: [],
  pagination:''
}
